"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    marginBottom: theme.spacing(1.5)
  },
  media: {
    display: "flex",
    alignItems: "center",
    overflowX: "scroll",
    flexWrap: "nowrap",
    marginLeft: theme.spacing(-.5),
    marginRight: theme.spacing(-.5)
    /*
     paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
     [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        marginLeft: theme.spacing(-3),
        marginRight: theme.spacing(-3),
    },
    */

  },
  figure: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    //        border: "1px solid",
    //        borderColor: "#999",
    margin: theme.spacing(.5),
    minWidth: theme.spacing(24),
    width: theme.spacing(24),
    height: theme.spacing(24),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(32),
      width: theme.spacing(32),
      height: theme.spacing(32)
    }
  },
  image: {
    display: "block",
    maxWidth: "90%",
    maxHeight: "90%"
  },
  more: {
    position: "absolute",
    backgroundColor: "white",
    boxShadow: theme.shadows[6],
    zIndex: 2,
    top: "50%",
    right: "0",
    transform: "translateY(-50%)",
    margin: theme.spacing(1)
  }
}));

const PrimusMediaPreview = ({
  formData = []
}) => {
  const classes = useStyles();

  if (!formData.length) {
    return false;
  }

  return _react.default.createElement("section", {
    className: classes.root
  }, _react.default.createElement(_IconButton.default, {
    className: classes.more
  }, _react.default.createElement(_ArrowForward.default, null)), _react.default.createElement("div", {
    className: classes.media
  }, formData.map((media, index) => {
    const imageUrl = media.media && media.media.imageUrl;
    return _react.default.createElement(_Paper.default, {
      square: true,
      className: classes.figure
    }, _react.default.createElement("img", {
      src: imageUrl,
      className: classes.image
    }));
  })));
};

var _default = PrimusMediaPreview;
exports.default = _default;
module.exports = exports.default;